import React, { useMemo } from 'react';

import { Badge, Button, Row, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Draggable } from 'react-beautiful-dnd';
import classnames from 'classnames';

import PropertiesItems from './PropertiesItems';

import './ColumnDraggable.less';

import { getPropertyByFieldFullPath } from 'pages/minimum-requirements/components/modal/utils';
import { getPropertyData } from '../utils';

const primaryButton = 0;

const ColumnDraggable = (props) => {
  const {
    index,
    fieldName,
    entityType,
    isSelected,
    isGhosting,
    propertiesData,
    selectionCount,
    toggleSelection,
    isMinimumRequirement = false,
    toggleSelectionInGroup,
    handleRemoveDataColumns,
  } = props;

  const getColumnPropertyData = () => {
    let data;

    const propertiesList =
      window?.advancedSearch?.entityAttributes?.[entityType] ?? propertiesData;

    if (isMinimumRequirement) {
      data = getPropertyByFieldFullPath({
        properties: propertiesList,
        fieldFullPath: fieldName,
      });
    } else {
      data = getPropertyData({ properties: propertiesList, fieldName });
    }

    return data;
  };

  const propertyData = useMemo(getColumnPropertyData, [
    fieldName,
    propertiesData,
    entityType,
    isMinimumRequirement,
  ]);

  // preventing if there was a drag
  const onClick = (event) => {
    if (event.defaultPrevented) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    // marking the event as used
    event.preventDefault();

    performAction(event);
  };

  // Determines if the platform specific toggle selection in group key was used
  const wasToggleInSelectionGroupKeyUsed = (event) => {
    const isUsingWindows = navigator.platform.indexOf('Win') >= 0;
    return isUsingWindows ? event.ctrlKey : event.metaKey;
  };

  const performAction = (event) => {
    if (wasToggleInSelectionGroupKeyUsed(event)) {
      toggleSelectionInGroup(fieldName + '_column', 'column');
      return;
    }

    toggleSelection(fieldName + '_column', 'column');
  };

  return (
    <Draggable draggableId={fieldName + '_column'} index={index}>
      {(provided, snapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {provided.placeholder}
            {propertyData?.fieldName ? (
              <Badge
                count={
                  snapshot.isDragging && selectionCount > 1
                    ? selectionCount
                    : null
                }
                className='property-item__badge'
              >
                <Tooltip
                  title={propertyData?.fullPathDisplayName}
                  placement='top'
                  arrowPointAtCenter
                >
                  <Row
                    gutter={4}
                    align='middle'
                    className={classnames({
                      'property-item': true,
                      'property-item__isDragging': snapshot.isDragging,
                      'property-item__isSelected': isSelected,
                      'property-item__isGhosting': isGhosting,
                    })}
                    onClick={onClick}
                  >
                    <PropertiesItems
                      dataType={propertyData?.dataType}
                      displayName={propertyData?.fullPathDisplayName}
                      isMinimumRequirement={isMinimumRequirement}
                    >
                      <Button
                        className='property-draggable__remove'
                        danger
                        type='text'
                        icon={<CloseOutlined style={{ fontSize: 14 }} />}
                        style={{ padding: '0 10px' }}
                        onClick={() => {
                          handleRemoveDataColumns(fieldName);
                        }}
                      />
                    </PropertiesItems>
                  </Row>
                </Tooltip>
              </Badge>
            ) : null}
          </div>
        );
      }}
    </Draggable>
  );
};

export default React.memo(ColumnDraggable);
